<template>
    <div class="checkbox app_slider_checkbox flex items-center" :class="switchClass">
        <span v-if="leftText" class="switch_text switch_text__left">
            {{ leftText }}
        </span>
        <label class="switch" @change="$emit('switch')">
            <input
                :id="id"
                :checked="checked"
                :name="name"
                type="checkbox"
                :value="modelValue"
                @change="$emit('update:modelValue', $event.target.checked)"
            />
            <span class="slider round"></span>
        </label>
        <span v-if="text" class="switch_text switch_text__right">
            {{ text }}
        </span>
    </div>
</template>

<script setup>
const emit = defineEmits(["switch"]);

const props = defineProps({
    id: {
        type: String,
        default: "",
    },
    name: {
        type: String,
        default: "",
    },
    text: {
        type: String,
        default: "",
    },
    leftText: {
        type: String,
        default: "",
    },
    switchClass: {
        type: String,
        default: "",
    },
    checked: {
        type: Number,
        default: false,
    },
    modelValue: {
        type: [String, Number],
        default: "",
    },
});
</script>

<style scoped>
.switch {
    @apply relative inline-block w-[3.875rem] h-8;
    /* position: relative;
    display: inline-block;
    width: 60px;
    height: 34px; */
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    @apply absolute cursor-pointer top-0 left-0 right-0 bottom-0 bg-gray-100 dark:bg-gray-500 dark:border-transparent;
    /* position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc; */
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    content: "";
    @apply absolute h-6 w-6 left-1 bottom-[0.1875rem] bg-dark-100 shadow;
    /* position: absolute;
    height: 24px;
    width: 24px;
    left: 4px;
    bottom: 3px;
    background-color: white; */
    -webkit-transition: 0.4s;
    transition: 0.4s;
}
.booking-slot-switch .slider:before {
    @apply bottom-[0.25rem];
}
input:checked + .slider {
    @apply bg-green-500;
    /* background-color: #2196f3; */
}

input:checked + .slider:before {
    -webkit-transform: translateX(1.8125rem);
    -ms-transform: translateX(1.8125rem);
    transform: translateX(1.8125rem);
}

/* Rounded sliders */
.slider.round {
    border-radius: 2.125rem;
}

.slider.round:before {
    border-radius: 50%;
}

.switch_text {
    @apply text-sm text-dark-200 dark:text-white font-normal;
}

.switch_text__left {
    @apply ltr:pr-3 rtl:pl-3;
}

.switch_text__right {
    @apply ltr:pl-2 rtl:pr-2;
}
</style>
